$(document).ready(function() {

  AOS.init({
      disable: window.matchMedia('(prefers-reduced-motion: reduce)')
  });

  $('.carousel').owlCarousel({
    loop:true,
    nav:false,
    dots: true,
    autoplay: true,
    autoplayHoverPause: true,
    items : 1,
    autoHeight: true
  });

  // centered dots on events page custom hover effect
  $('.nova__link-centered-dot--left-trigger').hover(function() {
    $('.nova__link-centered-dot--dot').css({'left':'5%', 'background-color':'#EC1A2E'});
  }, function() {
    // on mouseout, reset the background colour
    $('.nova__link-centered-dot--dot').css({'left':'40%', 'background-color': ''});
  });

  $('.nova__link-centered-dot--right-trigger').hover(function() {
    $('.nova__link-centered-dot--dot').css({'left':'70%', 'background-color':'#EC1A2E'});
  }, function() {
    // on mouseout, reset the background colour
    $('.nova__link-centered-dot--dot').css({'left':'40%', 'background-color': ''});
  });


  // image lazyloading
  $('body').imagesLoaded()
  .always( function( instance ) {
    $('.nova-page-wrapper').addClass('loaded');
    //$('.spinner').hide();
  });

  $('.navbar-burger').click(function() {
    $('.navbar-burger').toggleClass('is-active');
    $('.navbar-menu').toggleClass('is-active');
  });

  $(".dropdown").on("click", function(e) {
    if( $(window).width() < 1087) {
      $(this).parent().find('.navbar-dropdown').slideToggle();
      event.preventDefault();
      return false;
    }
  });


  let adminNav = $('#wpadminbar').length;
  if(adminNav > 0) {
    // console.log('admin nav on page');
    $('body').addClass('has-admin-nav');
  }


  // open modal
  $('.nova-gallery__view-image').click(function(e){
    let imageUrl = $(this).attr('href');
    $('.nova-gallery__modal img').attr('src', imageUrl);
    $('.nova-gallery__modal').addClass('is-active');
    return false;
  });

  // close modal
  $('.nova-gallery__modal').click(function(e){
    $('.nova-gallery__modal').removeClass('is-active');
  });

  $('.nova-faq').click(function(e){
    $(this).toggleClass('nova-faq__active');
    $(this).find('.nova-faq__answer').slideToggle();
  });

  $('.nova-expertise-slider__buttons').click(function(e){

    $('.nova-expertise-slider__buttons').removeClass('active');
    $(this).addClass('active');
    let id = $(this).data('id');

    // hide image and case studies
    // for the first one
    if(id == 0) {
      $('.nova-full_image--bg--small').hide();
    } else {
      $('.nova-full_image--bg--small').show();
    }

    $('.nova-expertise-slider__content, .nova-expertise-slider__content--item').removeClass('active');
    $('.nova-expertise-slider__content, .nova-expertise-slider__content--item').find("[data-id='" + id + "']").addClass('active');

    $('.nova-case_studies').removeClass('active');
    $(".nova-case_studies[data-id='" + id +"']").addClass('active');

  });

  // Configure/customize these variables.
    var showChar = 87;  // How many characters are shown by default
    var ellipsestext = "";
    var moretext = '<i class="fas fa-plus" aria-hidden="true"></i>';
    var lesstext = '<i class="fas fa-minus" aria-hidden="true"></i>';


  // link scroll to on click
  $('a[href*="#"]:not([href="#"])').click(function(e) {
      var target = $(this.hash);
      scrollTo(target.length ? target : $('[name=' + this.hash.slice(1) +']'));
  });


  // blog masonry layout activation

});

$(window).scroll(function(){
  // var sticky = $('.navbar'),
  //     scroll = $(window).scrollTop();
  // if (scroll >= 19) sticky.addClass('navbar__fixed');
  // else sticky.removeClass('navbar__fixed');
});

$(window).bind("load", function() {
  $( '.nova-news__posts' ).masonry();
});
